<template>
  <Tabs
    ref="PgFlashAddMedicalRef"
    v-model="activeName"
    :class="['pg-flash-add-medical', { 'pg-flash-add-medical-isActive': isActive }]"
    :style="{ width, top, right, zIndex }"
  >
    <TabPane label="药械闪加" name="optionAddMedical" v-if="flash">
      <optionAddMedical
        v-bind="flash"
        :requestParams="requestParams"
        @getMedicalData="getMedicalData"
        :disabled="disabled"
      ></optionAddMedical>
    </TabPane>
    <TabPane label="扫码添加" name="scanAddMedical" v-if="scan">
      <scanAddMedical
        v-bind="scan"
        @getMedicalData="getMedicalData"
        :requestParams="requestParams"
        :disabled="disabled"
      ></scanAddMedical>
    </TabPane>
  </Tabs>
</template>
<script setup>
// vue
import { ref, onBeforeMount, inject } from 'vue'
import { useRoute } from 'vue-router/composables'

// components
import { Loading, Tabs, TabPane } from 'element-ui'
import optionAddMedical from './option-add-medical.vue'
import scanAddMedical from './scan-add-medical.vue'
//hook
import { useFlashAddMedical } from '../hook/use-flash-add'
//utils
import { post, getElementTop } from '../../../utils/index'
import { sessionStorage } from 'pangu-core'
//token
import { PAGE_EDIT_SCROLL_INJECTION_KEY } from '../../../tokens/index'

const emit = defineEmits([])

// 获取公共方法
const { emitData } = useFlashAddMedical(emit)

const props = defineProps({
  flash: Object,
  scan: Object,
  disabled: Boolean, // 组件的disabled属性
  convertDataUrl: String,
  convertParams: Object,
  requestParams: Object,
  isFloat: {
    type: Boolean,
    default: true,
  },
})

const activeName = ref('optionAddMedical') // 当前激活的tab名称
const PgFlashAddMedicalRef = ref(null) // 当前组件的引用
const isActive = ref(false) // 药械闪加-是否需要激活浮动

// 组件属性
const width = ref('100%')
const top = ref(0)
const right = ref(0)
const zIndex = ref(0)

const { onPageEditScroll } = inject(PAGE_EDIT_SCROLL_INJECTION_KEY, {})
if (props.isFloat && onPageEditScroll) {
  onPageEditScroll((event) => {
    if (!PgFlashAddMedicalRef.value) {
      return
    }
    const fragment = document.getElementById('pg-flash-add-medical-fragment')

    if (fragment && event.target.scrollTop <= fragment.offsetTop) {
      fragment?.remove()
      isActive.value = false
      top.value = 0
      right.value = 0
      zIndex.value = 0
    } else if (event.target.scrollTop > PgFlashAddMedicalRef.value.$el.offsetTop) {
      if (fragment) return false
      // 准备一个药械闪加的占位元素-
      const flashFragment = document.createElement('div')
      flashFragment.innerHTML = '我是占位符'
      flashFragment.id = 'pg-flash-add-medical-fragment'
      flashFragment.style.width = '100%'
      flashFragment.style.color = '#fff'
      // 占位符放在药械闪加的前面
      flashFragment.style.height = PgFlashAddMedicalRef.value.$el.clientHeight + 'px'
      PgFlashAddMedicalRef.value.$el.before(flashFragment)

      // 把药械闪加组件浮动到顶部
      isActive.value = true
      top.value = `${getElementTop(event.target)}px`
      width.value = `${PgFlashAddMedicalRef.value.$el.parentElement.clientWidth}px`
      right.value = '26px'
      zIndex.value = 21
    }
  })
}

const convertDataMethod = (componentData) => {
  const loadingInstance = Loading.service({ background: 'rgba(0,0,0,0)', fullscreen: true })
  post(props.convertDataUrl, {
    ...componentData.parameters,
    ...props.convertParams,
    parameters: {
      ...componentData.parameters?.parameters,
      ...props.convertParams?.parameters,
    },
  })
    .then(([res, error]) => {
      loadingInstance?.close()
      emitData({
        ...componentData,
        data: res?.data,
        res: res ?? error,
      })
    })
    .catch(() => loadingInstance?.close())
}

const getMedicalData = (data) => {
  if (data.type == 'excelAdd' && !Object.keys(data.originData?.requestData ?? {})?.length) {
    emitData(data)
  } else if (props.convertDataUrl) {
    convertDataMethod(data)
  } else emitData(data)
}

onBeforeMount(() => {
  const route = useRoute()
  sessionStorage.remove(`${route.name}_pg-medical-excelAddOptions`)
})
</script>
<style lang="scss">
@import '../style/flash-add-medical.scss';
</style>
